<template>
<div class="download-parametric">
  <div id="download-protocol-pseudoform">
    <div v-for="param in protocolFields" v-if="param.isFile">
      <!-- Visible file inputs, not in form  -->
      <label>{{param.name && param.name.replace(/_/g, ' ')}}</label>
      <input
        name=""
        type="file"
        value=""
        @change="updateFile($event, param.name)"
      >
      </input>
      <select v-if="param.htmlElem === 'select'" :name="param.name">
        <option v-for="opt in param.options" :value="opt.value" :selected="opt.value === opt.default">{{opt.text}}</option>
      </select>
    </div>
    <form
      id="download-protocol-form"
      :action="fullDownloadUrl"
      method="GET"
      enctype="application/x-www-form-urlencoded"
    >
      <div v-for="param in protocolFields" v-if="!param.isFile">
        <label>
          {{param.name && param.name.replace(/_/g, ' ')}}
        </label>
        <input v-if="param.htmlElem === 'input' && !param.isFile"
          :name="param.name"
          :type="param.type"
          :value="param.default"
          :step="param.step"
        >
        </input>
        <select v-if="param.htmlElem === 'select'" :name="param.name">
          <option v-for="opt in param.options" :value="opt.value" :selected="opt.value === opt.default">{{opt.text}}</option>
        </select>
      </div>
      <!-- Hidden text inputs container file contents (serialized JSON) -->
      <div v-for="(fileString, filename) in files">
        <input :name="filename" type="hidden" :value="fileString" />
      </div>
      <!-- This special "fields" input tells the parser the original JSON describing pythonType, default, etc. -->
      <input name="fields" type="hidden" :value="specialFieldsKey" />
      <input
        type="submit"
        :value="'Download For ' + robotTab"
        id="download-protocol"
        :data-gtm-action="subdomain"
        data-gtm-category="Protocol-Download"
        :data-gtm-label="protocolSlug"
      />
    </form>
  </div>
</div>
</template>

<script>
  export default {
    name: 'ParameterizeAndDownload',
    props: ['downloadUrl', 'protocolParameters', 'protocolSlug', 'robotTab'],
    data: function () {
      return {
        files: {}
      }
    },
    methods: {
      updateFile (e, fieldName) {
        let reader = new window.FileReader()

        reader.onload = f => {
          const fileContents = f.target.result
          this.$set(this.files, fieldName, fileContents)
        }
        reader.readAsText(e.target.files[0])
      }
    },
    computed: {
      specialFieldsKey () {
        if (!this.protocolParameters) {
          console.warn('No protocol parameters')
        }
        const fields = Object.values(this.protocolParameters) || []
        return JSON.stringify(fields)
      },
      subdomain () {
        const subdomain = window.location.href.split('://')[1].split('.')[0]
        // http://protocols.opentrons.com URLs -> subdomain is 'master'
        return subdomain === 'protocols' ? 'master' : subdomain
      },
      fullDownloadUrl () {
        return this.downloadUrl // TODO: just use prop, no need for fullDownloadUrl()
      },
      protocolFields () {
        if (!this.protocolParameters) {
          return
        }

        return this.protocolParameters.map(param => {
          const pythonType = param.annotation && param.annotation.type

          if (['StringSelection'].includes(pythonType)) {
            return {
              htmlElem: 'select',
              name: param.name,
              default: param.default,
              options: param.annotation.options
            }
          }

          const stepVals = {int: '1', float: 'any'}

          // map param.annotation.type to <input> type:
          const inputTypes = {
            int: 'number',
            float: 'text',
            FileInput: 'file'
          }

          return {
            htmlElem: 'input',
            isFile: pythonType === 'FileInput',
            name: param.name,
            default: param.default,
            type: inputTypes[pythonType],
            step: stepVals[param.annotation]
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ParameterizeAndDownload.vue?3b31bb1d